import { useRef } from "react";
import useElementDimensions from "hooks/useElementDimensions";
import useNaturalWidth from "components/navigation/useNaturalWidth";
const MEASURE_DEBOUNCE_MS = 0;
const useNavigationCollapse = () => {
  const navbarRef = useRef(null);
  const brandRef = useRef(null);
  const badgesRef = useRef(null);
  const iconsRef = useRef(null);
  const { width: navbarWidth } = useElementDimensions(navbarRef, MEASURE_DEBOUNCE_MS);
  const { width: brandWidth } = useElementDimensions(brandRef, MEASURE_DEBOUNCE_MS);
  const { width: badgesWidth } = useElementDimensions(badgesRef, MEASURE_DEBOUNCE_MS);
  const { width: iconsWidth } = useElementDimensions(iconsRef, MEASURE_DEBOUNCE_MS);
  const [menuRef, menuWidth] = useNaturalWidth();
  const availableWidth = navbarWidth - brandWidth - badgesWidth - iconsWidth;
  const collapsed = menuWidth > 0 && menuWidth > availableWidth;
  return { navbarRef, brandRef, badgesRef, iconsRef, menuRef, collapsed };
};
export default useNavigationCollapse;
